import React from 'react';
import PropTypes from 'prop-types';

import { NumberHelper } from '../../helpers/NumberHelper';
import { getDebitCartTax } from '../../helpers/CartHelper';
import styles from './CheckoutInvoice.css';

const IPropTypes = {
  extraShippingCost: PropTypes.number,
  productAmount: PropTypes.number.isRequired,
  shippingPrice: PropTypes.number,
  totalPrice: PropTypes.number.isRequired,
  totalProductPrice: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  cart: PropTypes.object,
};

const defaultProps = {
  extraShippingCost: 0,
  shippingPrice: 0,
  cart: null,
};

const CheckoutInvoice = (props) => {
  const debitCardTax = getDebitCartTax(props.cart);
  const priceDebitCardTax = debitCardTax && debitCardTax.product ?
    debitCardTax.product.financing.price : 0;
  return (
    <div className={styles.container}>
      <div className={styles.invoiceLine}>
        <p className={styles.invoiceText}>
          Subtotal ({props.productAmount})
        </p>
        <p className={styles.invoiceText}>
          ${NumberHelper.localizeNumber(props.totalProductPrice - priceDebitCardTax)}
        </p>
      </div>
      {debitCardTax && debitCardTax.product &&
        <div className={styles.invoiceLine}>
          <p className={styles.invoiceText}>
            Adicional por forma de pago
          </p>
          <p className={styles.invoiceText}>
            ${NumberHelper.localizeNumber(priceDebitCardTax)}
          </p>
        </div>
      }
      {
        !!props.shippingPrice &&
        <div className={styles.invoiceLine}>
          <p className={styles.invoiceText}>
            Envío
          </p>
          <p className={styles.invoiceText}>
            ${NumberHelper.localizeNumber(props.shippingPrice)}
          </p>
        </div>
      }
      {
        !!props.extraShippingCost &&
        <div className={styles.invoiceLine}>
          <p className={styles.invoiceText}>
            Piso de Agencia
          </p>
          <p className={styles.invoiceText}>
            ${NumberHelper.localizeNumber(props.extraShippingCost)}
          </p>
        </div>
      }
      <div className={styles.invoiceTotalContainer}>
        <div className={styles.invoiceLine}>
          <p className={styles.invoiceTotal}>
            Total
          </p>
          <p className={styles.invoiceTotal}>
            ${NumberHelper.localizeNumber(props.totalPrice)}
          </p>
        </div>
      </div>
    </div>
  );
};

CheckoutInvoice.propTypes = IPropTypes;
CheckoutInvoice.defaultProps = defaultProps;

export { CheckoutInvoice };



// WEBPACK FOOTER //
// ./src/common/checkout-invoice/CheckoutInvoice.jsx